import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { Box } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import { FlexRow } from "@similarweb/ui-components";
import { setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon, navigation } = colorsPalettes;

const Y_AXIS_MARGIN = 12;

export const MarketBuilderWrapper = styled(FlexColumn)`
    margin: ${Y_AXIS_MARGIN}px 40px;
    height: calc(100% - ${2 * Y_AXIS_MARGIN}px);
`;

export const BackButton = styled(IconButton)`
    margin: 0 0 12px -16px;
    min-height: 37px;
`;

export const TopRow = styled(FlexRow)`
    justify-content: space-between;
`;

export const HeaderWrapper = styled.div`
    margin-bottom: 24px;
`;

export const Title = styled.div`
    ${setFontVariant("h4", carbon[500])}
    line-height: 32px;
    margin-bottom: 4px;
`;

export const Subtitle = styled.div`
    ${setFontVariant("body2", carbon[300])}
    line-height: 20px;
`;

export const YourListWrapper = styled.div`
    width: 25%;
    border: 1px solid ${navigation["BORDER_DARK_1"]};
    margin: 24px;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 24px;
`;

export const TabsContainer = styled.div`
    width: 75%;
`;

export const ContentWrapper = styled(Box)`
    display: flex;
    width: 100%;
    height: initial;
    flex: 1 1 auto;
`;

export const SaveBtnContainer = styled(FlexRow)``;

export const StyledList = styled.ul`
    margin-left: 20px;
    margin-bottom: 0;
    list-style-type: disc;
`;

export const StyledListItem = styled.li``;
